import { Space, Tag } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSelectedCandidates, setSelectedCandidate } from "../../../Slices/hiringSlice";
import { AntdButton } from "../../../blueplanitUtils/InputField";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { useNavigate } from "react-router-dom";

const statusColors = {
    Selected: "green"
};

const offerStageColors = {
    "Not Started": "default",
    "Offer In Progress": "processing",
    "Offer Released": "blue",
    "Accepted": "green",
    "Declined": "red"
};

const OfferList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const selectedCandidates = useSelector((state) => state.hiring.selectedCandidates);

    useEffect(() => {
        dispatch(fetchSelectedCandidates());
    }, [dispatch]);

    const handleRowclick = (record) => {
        navigate(`/offerManagement/${record.id}`);
        dispatch(setSelectedCandidate(record));
    }

    const columns = [
        {
            title: "Name Of The Candidate",
            key: "name",
            render: (_, row) => `${row.firstName} ${row.lastName || ""}`
        },
        {
            title: "Job Title",
            dataIndex: "jobTitle",
        },
        // {
        //     title: "Dept & Location",
        //     render: (row) => `${row.department} - ${row.location}`,
        // },
        {
            title: "Status",
            dataIndex: "result",
            render: (status) => (
                <Tag color={statusColors[status] || "default"}>
                    {status}
                </Tag>
            ),
        },
        {
            title: "Offer Stage",
            dataIndex: "offerStage",
            key: "offerStage",
            render: (stage) => (
                <Tag color={offerStageColors[stage]}>{stage}</Tag>
            )
        },
        {
            title: "Actions",
            render: (_, record) => (
                <Space>
                    <AntdButton
                        label="Create Offer"
                        color="primary" 
                        variant="outlined"
                        onClick={() => handleRowclick(record)}
                    />
                </Space>
            ),
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <CustomGridTable
                                rowKey="id"
                                style={{ width: "100%", tableLayout: "auto" }}
                                columns={columns}
                                dataSource={selectedCandidates}
                                pagination={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfferList;
